import { render, staticRenderFns } from "./PricingBox.vue?vue&type=template&id=e286649a&scoped=true&"
import script from "./PricingBox.vue?vue&type=script&lang=js&"
export * from "./PricingBox.vue?vue&type=script&lang=js&"
import style0 from "./PricingBox.vue?vue&type=style&index=0&id=e286649a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e286649a",
  null
  
)

export default component.exports